import { createRoot } from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import "katex/dist/katex.min.css"
import "./shadcn.css"
import App from "./App"
import { trpc, createTRPCClient } from "./lib/trpc"

const queryClient = new QueryClient()
const trpcClient = createTRPCClient()

const root = createRoot(document.getElementById("app")!)
root.render(
  <trpc.Provider client={trpcClient} queryClient={queryClient}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </trpc.Provider>,
)
